









import { requirementListInstance } from '@/model/RequirementListClass';
import { CLOSE_TAG_VIEW_EVENT, pubsub } from '@/utils/pubsub';
import { Component, Vue } from 'vue-property-decorator';
import EditRequirementForm from './components/editRequirementForm.vue';
import moment from 'moment';

type IUpdateRequirementInfo = IRequirement.IModel.IUpdateRequirementInfo;

@Component({
  components: {
    EditRequirementForm,
  },
})
export default class CreateRequirement extends Vue {
  private requirementInfo: IUpdateRequirementInfo = {
    title: '',
    description: '',
    issueId: '',
    projectId: '',
    projectName: '',
    urgency: 0,
    due: moment().format(),
  };
  private createRequirement(
    updateInfo: IUpdateRequirementInfo,
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      requirementListInstance
        .requestCreateItem(updateInfo)
        .then((res) => {
          resolve(res);
          this.goBack();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  private goBack() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.go(-1);
  }
}
